// ==============================|| ENQUIRIES ITEMS - ENQURIES ||============================== //

import { PERMISSIONS } from '../permissions/permissions';

const couponsComponents = {
  id: 'coupons',
  path: '/coupons',
  type: 'group',
  children: [
    {
      id: 'coupons-elements',
      title: 'menu.coupons',
      type: 'collapse',
      icon: 'ph ph-seal-percent',
      children: [
        {
          id: 'coupons-list',
          title: 'menu.allCoupons',
          type: 'item',
          url: '/coupons/view-coupon-codes',
          permission: PERMISSIONS.COUPONS_CODE.VIEW
        }
      ]
    }
  ]
};

export default couponsComponents;
